var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, QueryList } from '@angular/core';
import { CheckboxWidget } from './checkbox.widget';
import { isWidgetRequired } from './overrides';
var TagListWidget = (function (_super) {
    __extends(TagListWidget, _super);
    function TagListWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._listSearch = '';
        _this.placeholder = '';
        _this.listOpen = false;
        _this.listSelectedIndex = -1;
        _this.listHasFocus = false;
        _this.searchHasFocus = false;
        _this.openDirection = 'down';
        _this.maxHeight = 'none';
        _this.onScrollBound = _this.onScroll.bind(_this);
        return _this;
    }
    TagListWidget.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
        // Set placeholder from schema options
        this.placeholder = (this.schema.items &&
            !Array.isArray(this.schema.items) &&
            this.schema.items.options &&
            typeof this.schema.items.options.enumBlankTitle !== 'undefined') ? this.schema.items.options.enumBlankTitle : 'Please select';
    };
    Object.defineProperty(TagListWidget.prototype, "listSearch", {
        get: function () {
            return this._listSearch;
        },
        set: function (search) {
            if (search.trim() === '') {
                this.listSelectedIndex = -1;
            }
            else if (this.listSearch !== search) {
                this.listSelectedIndex = 0;
            }
            this._listSearch = search;
        },
        enumerable: true,
        configurable: true
    });
    TagListWidget.prototype.tagIdentity = function (index, tag) {
        return tag.value;
    };
    TagListWidget.prototype.focusSearch = function () {
        this.searchField.nativeElement.focus();
    };
    TagListWidget.prototype.wrapperClick = function ($event) {
        if (this.wrapper && $event.target === this.wrapper.nativeElement) {
            this.focusSearch();
        }
    };
    TagListWidget.prototype.tagKeydown = function (tag, $event) {
        var _this = this;
        if (this.schema.readOnly)
            return;
        var tagIndex = this.tagElements.toArray().findIndex(function (_tag) { return _tag.nativeElement === $event.target; });
        switch ($event.key) {
            case 'ArrowLeft':
            case 'ArrowRight':
                var newSelection = tagIndex + ($event.key === 'ArrowLeft' ? -1 : 1);
                if (newSelection === -1 || newSelection === this.tagElements.length) {
                    this.focusSearch();
                }
                else {
                    this.focusTag(newSelection);
                }
                break;
            case 'Delete':
            case 'Backspace':
                this.checkToggle(tag);
                setTimeout(function () {
                    if (_this.tagElements.length === 0) {
                        _this.focusSearch();
                    }
                    else {
                        _this.focusTag(tagIndex);
                    }
                }, 0);
                break;
            case 'Shift':
            case 'Control':
            case 'Meta':
            case 'Alt':
            case 'Tab':
                // Nothing
                break;
            default:
                // Redirect all typing to the search
                this.focusSearch();
                break;
        }
    };
    TagListWidget.prototype.searchKeydown = function ($event) {
        var _this = this;
        var mod = (this.searchResults.length + 1);
        switch ($event.key) {
            case 'ArrowUp':
                if ($event.shiftKey || $event.altKey || $event.ctrlKey || $event.metaKey)
                    break;
                $event.preventDefault();
                this.openList();
                this.listSelectedIndex = ((this.listSelectedIndex + mod + 0) % mod) - 1;
                setTimeout(function () { return _this.scrollListToActiveItem(); });
                break;
            case 'ArrowDown':
                if ($event.shiftKey || $event.altKey || $event.ctrlKey || $event.metaKey)
                    break;
                $event.preventDefault();
                this.openList();
                this.listSelectedIndex = ((this.listSelectedIndex + mod + 2) % mod) - 1;
                setTimeout(function () { return _this.scrollListToActiveItem(); });
                break;
            case 'ArrowLeft':
            case 'ArrowRight':
                if ($event.shiftKey || $event.altKey || $event.ctrlKey || $event.metaKey)
                    break;
                if (this.tagElements.length === 0)
                    break;
                var direction = $event.key === 'ArrowLeft' ? -1 : 1;
                var selectionRange = window.getSelection().getRangeAt(0);
                var cursorPos = (direction === -1 ? selectionRange.startOffset : selectionRange.endOffset) + direction;
                if (cursorPos < 0) {
                    this.focusTag(this.tagElements.length - 1);
                }
                else if (cursorPos > this.listSearch.length) {
                    this.focusTag(0);
                }
                break;
            case 'Escape':
                $event.preventDefault();
                if (this.listSearch.length > 0) {
                    this.listSearch = '';
                }
                else {
                    this.closeList();
                }
                break;
            case 'Enter':
                $event.preventDefault();
                if (this.listSelectedIndex !== -1) {
                    this.checkToggle(this.searchResults[this.listSelectedIndex]);
                    this.resetSearch();
                }
                break;
            case 'Backspace':
                if (this.listSearch.length === 0 && this.selectedTags.length) {
                    this.removeTag(this.selectedTags.length - 1);
                }
                break;
            default:
                this.openList();
                break;
        }
    };
    TagListWidget.prototype.searchFocus = function ($event) {
        this.searchHasFocus = true;
        this.openList();
    };
    TagListWidget.prototype.searchBlur = function ($event) {
        if (this.listHasFocus)
            return;
        this.searchHasFocus = false;
        this.maybeCloseList();
    };
    TagListWidget.prototype.listFocus = function ($event) {
        var _this = this;
        this.listHasFocus = true;
        setTimeout(function () { return _this.focusSearch(); });
    };
    TagListWidget.prototype.listBlur = function ($event) {
        this.listHasFocus = false;
        this.maybeCloseList();
    };
    TagListWidget.prototype.resetSearch = function () {
        this.listSearch = '';
        this.listSelectedIndex = -1;
    };
    TagListWidget.prototype.clickListOption = function (option) {
        this.checkToggle(option);
        this.resetSearch();
        this.focusSearch();
    };
    TagListWidget.prototype.openList = function () {
        if (!this.listOpen) {
            this.listSelectedIndex = -1;
        }
        this.listOpen = true;
    };
    TagListWidget.prototype.maybeCloseList = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.searchHasFocus && !_this.listHasFocus) {
                _this.closeList();
            }
        });
    };
    TagListWidget.prototype.closeList = function () {
        this.listOpen = false;
        this.listSelectedIndex = -1;
        this.listSearch = '';
    };
    TagListWidget.prototype.focusTag = function (index) {
        this.closeList();
        var elements = this.tagElements.toArray();
        if (elements.length) {
            index = Math.min(index, elements.length - 1);
            elements[index].nativeElement.focus();
        }
    };
    TagListWidget.prototype.removeTag = function (index) {
        this.checkToggle(this.selectedTags[index]);
    };
    TagListWidget.prototype.cleanPaste = function ($event) {
        $event.preventDefault();
        var content = $event.clipboardData.getData('text/plain');
        content = content.replace(/\n/g, ' ');
        document.execCommand("insertHTML", false, content);
    };
    Object.defineProperty(TagListWidget.prototype, "selectedTags", {
        get: function () {
            var _this = this;
            return Object.keys(this.checked)
                .map(function (value) { return _this.options.find(function (option) { return option.value === value; }); })
                .filter(function (option) { return option && !_this.exclusiveOptionValues.includes(option.value); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagListWidget.prototype, "availableTags", {
        get: function () {
            var _this = this;
            return this.options.filter(function (option) { return !_this.checked[option.value] && !_this.isExclusive(option); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagListWidget.prototype, "searchResults", {
        get: function () {
            var _this = this;
            return this.availableTags.filter(function (tag) {
                return tag.label.toLowerCase().search(_this.listSearch.trim().toLowerCase()) !== -1;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagListWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TagListWidget.prototype, "showPlaceholder", {
        get: function () {
            return this.selectedTags.length === 0 && this.listSearch.trim() === '';
        },
        enumerable: true,
        configurable: true
    });
    TagListWidget.prototype.onScroll = function (e) {
        var rect = this.searchField.nativeElement.getBoundingClientRect();
        var top = rect.top;
        var bottom = window.innerHeight - rect.bottom;
        if (top < bottom) {
            this.openDirection = 'down';
            this.maxHeight = (bottom - 10) + 'px';
        }
        else {
            this.openDirection = 'up';
            this.maxHeight = (top - 10) + 'px';
        }
    };
    TagListWidget.prototype.scrollListToActiveItem = function () {
        var list = this.listElement.nativeElement;
        var canScroll = list.clientHeight < list.scrollHeight;
        if (!canScroll)
            return;
        var item = list.querySelector('.active');
        if (!item)
            return;
        var itemTop = item.offsetTop;
        var itemBottom = itemTop + item.offsetHeight;
        if (itemTop < list.scrollTop) {
            list.scrollTop = itemTop;
            return;
        }
        if (itemBottom > list.clientHeight + list.scrollTop) {
            list.scrollTop = itemBottom - list.clientHeight;
            return;
        }
    };
    TagListWidget.prototype.ngOnInit = function () {
        window.addEventListener('scroll', this.onScrollBound, true);
    };
    TagListWidget.prototype.ngOnDestroy = function () {
        window.removeEventListener('scroll', this.onScrollBound, true);
    };
    return TagListWidget;
}(CheckboxWidget));
export { TagListWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/taglist.widget.ts.pre-build-optimizer.js